// extracted by mini-css-extract-plugin
export default {"card":"Song_card__kcxpd","text":"Song_text__q3FCx","media":"Song_media__mHQfT"};